// Shared display formatters.

// Number -> "2,29 EUR" (Croatian retail: comma decimal, then the euro symbol
// after the amount). The separator is a non-breaking space, written as the
// \u00A0 escape so there is no literal irregular whitespace in source, so the
// amount and symbol never wrap apart. Empty string for missing/NaN input; every
// call site already guards on null, so this is a defensive fallback only.
export function formatEur(num) {
  if (num === null || num === undefined || Number.isNaN(num)) return ''
  return `${num.toFixed(2).replace('.', ',')}\u00A0€`
}

// ISO timestamp (e.g. a scan's `scannedAt`) -> local "DD.MM.YYYY." (Croatian date
// convention, trailing dot included). Empty string for missing/invalid input.
export function formatLocalDate(isoString) {
  if (!isoString) return ''
  const d = new Date(isoString)
  if (Number.isNaN(d.getTime())) return ''
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}.`
}
